<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-row">
        <div class="list-header-title-div">二级渠道列表</div>
        <div class="page-action-btns flex">
          <button class="common-bg-button" @click="goBack">返 回</button>
        </div>
      </div>

      <el-table :data="channelList" size="small" border style="width: 100%">
        <el-table-column prop="activityName" label="关联活动" min-width="140">
          <template slot-scope="{ row }">{{ row.activityName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentName" label="渠道名称" min-width="180">
          <template slot-scope="{ row }">{{ row.channelName || row.agentName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="账号(手机号)" min-width="130">
          <template slot-scope="{ row }">{{ row.phone || row.mobile || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentLevel" label="渠道级别" min-width="110">
          <template slot-scope="{ row }">
            <span class="level-tag level-two">{{ getAgentLevelText(row.channelLevel || row.agentLevel) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.statusEnabled" :active-value="true" :inactive-value="false"
              @change="handleStatusChange(row)" />
            <span class="status-text">{{ row.statusEnabled ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="qrcode" label="推广二维码" min-width="110" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" icon="el-icon-view" @click="handleViewQrcode(row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="registeredCount" label="已报名人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.registeredCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="pendingActivateCount" label="待激活人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.pendingActivateCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="usedCount" label="已使用人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.usedCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="createdWhen" label="创建时间" min-width="170">
          <template slot-scope="{ row }">{{ row.createdWhen || row.createTime || '-' }}</template>
        </el-table-column>
      </el-table>

      <div class="list-pagination">
        <el-pagination background layout="total, prev, pager, next, sizes, jumper" :current-page="pagination.current"
          :page-size="pagination.pageSize" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>

      <!-- 推广二维码弹窗 -->
      <el-dialog :title="qrcodeDialogTitle" :visible.sync="qrcodeDialogVisible" width="360px" center
        @close="qrcodeDialogVisible = false; qrcodeDataUrl = ''">
        <div class="qrcode-dialog-body" v-if="currentChannel">
          <p class="agent-name">{{ currentChannel.channelName || currentChannel.agentName || '-' }}</p>
          <p class="agent-info-subtitle">
            账号: {{ currentChannel.phone || currentChannel.mobile || '-' }} |
            级别: {{ getAgentLevelText(currentChannel.channelLevel || currentChannel.agentLevel) }}
          </p>
          <div class="qrcode-placeholder">
            <img v-if="qrcodeDataUrl" :src="qrcodeDataUrl" class="qrcode-img" alt="推广二维码" />
            <i v-else class="el-icon-picture-outline" style="font-size: 120px; color: #dcdfe6;"></i>
            <p class="qrcode-tip">扫码推广</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleDownloadQrcode">下载二维码</el-button>
          <el-button @click="qrcodeDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

const ACTIVITY_TYPE = "AXB_598_ACTIVITY_PAY";

export default {
  name: "AxbChannelLevel2List",
  data() {
    return {
      parentId: "",
      parentChannelName: "",
      channelList: [],
      pagination: { current: 1, pageSize: 10, total: 0 },
      queryInfo: { pageNum: 1, pageSize: 10 },
      qrcodeDialogVisible: false,
      currentChannel: null,
      qrcodeDataUrl: "",
      breadCrumb: [
        { name: "营销活动" },
        { name: "安心包598活动" },
        { name: "渠道管理", type: "router", router: "axbAgentList" },
        { name: "二级渠道列表" },
      ],
    };
  },
  computed: {
    qrcodeDialogTitle() {
      const name = this.currentChannel ? (this.currentChannel.channelName || this.currentChannel.agentName || "-") : "推广";
      return `${name} - 专属二维码`;
    },
  },
  mounted() {
    this.parentId = this.$route.query.parentId || "";
    this.parentChannelName = this.$route.query.parentChannelName || "";
    if (this.parentId) {
      this.getListData(this.pagination, true);
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "axbAgentList" });
    },
    getListData(pagination, reload = false) {
      const _ = this;
      if (!_.parentId) { _.channelList = []; return; }
      _.$U.showLoading(_);
      if (reload) { _.pagination.current = 1; _.queryInfo.pageNum = 1; }
      else { _.pagination.current = pagination.current; _.queryInfo.pageNum = pagination.current; }
      _.queryInfo.pageSize = pagination.pageSize;
      const params = {
        activityType: ACTIVITY_TYPE,
        agentLevel: 2,
        parentId: _.parentId,
        pageNum: (_.queryInfo.pageNum || 1) - 1,
        pageSize: _.queryInfo.pageSize || 10,
      };
      _.$H.post(_, _.$A.agent.findByPage, params).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        const list = payload?.content ?? payload?.list ?? payload?.records ?? [];
        _.channelList = (Array.isArray(list) ? list : []).map((item) => ({
          ...item,
          statusEnabled: item.status === "00" || item.status === "ENABLED" || item.status === 1,
        }));
        _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
      }).catch(() => { _.channelList = []; _.pagination.total = 0; })
        .finally(() => { _.$U.hideLoading(_); });
    },
    handleCurrentChange(page) { this.pagination.current = page; this.getListData(this.pagination, false); },
    handleSizeChange(size) { this.pagination.pageSize = size; this.pagination.current = 1; this.getListData(this.pagination, true); },
    handleStatusChange(row) {
      const _ = this;
      const newStatus = row.statusEnabled ? "00" : "01";
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.agent.updateAgentStatus, { id: row.id, status: newStatus })
        .then(() => { _.$message.success("状态更新成功"); })
        .catch(() => { row.statusEnabled = !row.statusEnabled; })
        .finally(() => { _.$U.hideLoading(_); });
    },
    getPromotionQrcodeUrl(phone) {
      return `alipays://platformapi/startapp?appId=2021006136673279&page=pages/shareIndex/index&query=sharedMerchant%3D${phone || ""}`;
    },
    handleViewQrcode(row) {
      this.currentChannel = row; this.qrcodeDataUrl = ""; this.qrcodeDialogVisible = true;
      this.$nextTick(() => this.generateQrcode());
    },
    generateQrcode() {
      if (!this.currentChannel) return;
      const phone = this.currentChannel.phone || this.currentChannel.mobile || "";
      QRCode.toDataURL(this.getPromotionQrcodeUrl(phone), { width: 200, margin: 2 })
        .then((dataUrl) => { this.qrcodeDataUrl = dataUrl; })
        .catch(() => { this.$message.error("二维码生成失败"); });
    },
    handleDownloadQrcode() {
      if (!this.currentChannel) return;
      const phone = this.currentChannel.phone || this.currentChannel.mobile || "";
      const name = this.currentChannel.channelName || this.currentChannel.agentName || phone || "channel";
      const fileName = `推广二维码_${String(name).replace(/[/\\?%*:|"<>]/g, "_")}.png`;
      QRCode.toDataURL(this.getPromotionQrcodeUrl(phone), { width: 300, margin: 2 }).then((dataUrl) => {
        const link = document.createElement("a"); link.href = dataUrl; link.download = fileName; link.click();
        this.$message.success("二维码已下载");
      }).catch(() => { this.$message.error("二维码下载失败"); });
    },
    getAgentLevelText(level) {
      const map = { LEVEL_ONE: "一级", LEVEL_TWO: "二级", "1": "一级", "2": "二级", 1: "一级", 2: "二级" };
      return map[level] || map[String(level)] || level || "-";
    },
  },
};
</script>

<style lang="less" scoped>
.list-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-action-btns {
  gap: 12px;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.status-text {
  margin-left: 8px;
  font-size: 12px;
  color: #606266;
}

.level-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.level-two {
    background: #f0f9eb;
    color: #67c23a;
  }
}

.qrcode-dialog-body {
  text-align: center;
  padding: 16px 0;

  .agent-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    color: #303133;
  }

  .agent-info-subtitle {
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;
  }

  .qrcode-placeholder {
    padding: 24px;
    background: #f5f7fa;
    border-radius: 8px;

    .qrcode-img {
      width: 200px;
      height: 200px;
      display: block;
      margin: 0 auto;
    }

    .qrcode-tip {
      margin-top: 12px;
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>
